import React, { useEffect, useState } from 'react';
// import StudentAppointmentTable from '../ui/StudentAppointmentTable.js';
import StudentClassesTable from '../ui/StudentClassesTable.js';
import StudentButtons from "../ui/StudentButtons.js";
import Container from 'react-bootstrap/Container';
import Stack from 'react-bootstrap/Stack';
import { db, auth } from '../firebase/config.js';
import { doc, getDoc, collection, getDocs } from 'firebase/firestore';
import '../App.css';


function StudentDashboard() {
    const [userName, setUserName] = useState('');


    useEffect(() => {
        const user = auth.currentUser;
        if (user) {
            const userDocRef = doc(db, "users", user.uid);
            getDoc(userDocRef).then(docSnapshot => {
                if (docSnapshot.exists()) {
                    const data = docSnapshot.data();
                    setUserName(`${data.firstName} ${data.lastName}`);
                    console.log(data.firstName);

                }
            }).catch(error => {
                console.error("Error fetching user data: ", error);
            });
        }
    }, []);

   

    return (
        <div>
            <Container className="bg-white p-4 shadow-sm rounded">
                <Stack gap={5}>
                    <div><h1 className="custom-font">Hello {userName}!</h1></div>
                    <div>
                        <h2 className="custom-font">Your Appointments</h2>

                        <StudentButtons />
                        {/* <StudentAppointmentTable /> */}
                    </div>
                    <div>
                        <h2 className="custom-font">Your Classes</h2>
                        <StudentClassesTable />
                    </div>
                    <div></div>
                </Stack>
            </Container>
        </div>
    )
}

export default StudentDashboard;